// extracted by mini-css-extract-plugin
export var footerMainInner = "footer-main-module--footer-main-inner--f1mcr";
export var footerNav = "footer-main-module--footer-nav--3zWl0";
export var footerMain = "footer-main-module--footer-main--2wjGv";
export var footerBackground = "footer-main-module--footer-background--3D8W1";
export var copyrightSection = "footer-main-module--copyright-section--3RviK";
export var footerForm = "footer-main-module--footer-form--Jem6v";